import {NgModule} from '@angular/core';
import {LoginComponent} from './login.component';
import {LoginSceneComponent} from './login-scene.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatSnackBarModule} from '@angular/material/snack-bar';

@NgModule({
  declarations: [
    LoginComponent,
    LoginSceneComponent
  ],
  imports: [
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatSnackBarModule,
    CommonModule,
    FormsModule,
  ],
  // Kept: AppModule imports this module and may rely on these re-exports.
  exports: [
    MatButtonModule,
    MatCardModule
  ],
  providers: [],
})
export class LoginModule {
}
